import { useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import DomainOutlinedIcon from "@mui/icons-material/DomainOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

import WarehouseDetails from "./WarehouseDetails";
import BuildingMapping from "./BuildingMapping";
import InviteUsers from "./InviteUsers";
import { useNavigate } from "react-router-dom";

const steps = [
  { label: "Warehouse Details", description: "Set up your warehouse.", icon: <WarehouseOutlinedIcon /> },
  { label: "Mapping First Building", description: "Set up your first building.", icon: <DomainOutlinedIcon /> },
  //{ label: "Inviting the User", description: "Set up your initial users to your warehouse.", icon: <GroupsOutlinedIcon /> },
];

const WarehouseOnboarding = () => {
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const progress = ((activeStep + 1) / steps.length) * 100;

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        height: "100vh",
        width: "100%",
        boxShadow: "none",
      }}
    >
      {/* LEFT SIDE */}
      <Box
        sx={{
          width: { xs: "100%", md: "30%" },
          borderRight: { md: "1px solid rgba(74, 85, 101, 0.1)" },
          borderBottom: { xs: "1px solid rgba(74, 85, 101, 0.1)", md: "none" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* TOP - PROGRESS */}
        <Box sx={{ p: 3 }}>
          <Typography variant="caption" sx={{ color: "primary.main" }}>
            Step {activeStep + 1} of {steps.length}
          </Typography>

          <Box>
            <Box
              sx={{
                height: 6,
                borderRadius: 3,
                bgcolor: "#E5E7EB",
                overflow: "hidden",
                mt: 1,
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  width: `${progress}%`,
                  transition: "width 0.3s ease",
                  bgcolor: "#005EFF",
                }}
              />
            </Box>
          </Box>

          <Typography variant="body2" color="#64748B" mt={1}>
            {steps[activeStep].description}
          </Typography>
        </Box>

        {/* MIDDLE - CENTERED MENU */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            px: { xs: 2, md: 6 },
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {steps.map((step, index) => {
              const isActive = index === activeStep;
              const isCompleted = index < activeStep;

              return (
                <Box
                  key={step.label}
                  onClick={() => setActiveStep(index)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    p: 1.5,
                    borderRadius: 1.5,
                    cursor: "pointer",
                    bgcolor: isActive ? "#F1F5F9" : "transparent",
                    transition: "all 0.2s ease",
                  }}
                >
                  <Box
                    sx={{
                      color: isActive
                        ? "#005EFF"
                        : isCompleted
                        ? "#94A3B8"
                        : "#CBD5E1",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {step.icon}
                  </Box>

                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: isActive ? 600 : 400,
                      color: isActive ? "#0F172A" : "#94A3B8",
                    }}
                  >
                    {step.label}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>

      {/* RIGHT SIDE */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        {/* MIDDLE - SCROLLABLE CONTENT */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            p: { xs: 2, md: 4 },
          }}
        >
          {activeStep === 0 && (
            <WarehouseDetails onNext={() => setActiveStep(1)} />
          )}

          {activeStep === 1 && (
            <BuildingMapping
              onBack={() => setActiveStep(0)}
              onNext={() => navigate("/dashboard")}
            />
          )}

          {/* {activeStep === 2 && (
            <InviteUsers
              onBack={() => setActiveStep(1)}
              onNext={() => navigate("/dashboard")}
            />
          )} */}
        </Box>
      </Box>
    </Paper>
  );
};
export default WarehouseOnboarding;
